import { SpecialistReview } from '@mindly/ui-components';
import { RootState } from '../index';

export const specialistReviewsSelector =
  (id: string) =>
  (state: RootState): SpecialistReview[] | null => {
    return state?.specialistReviews?.reviews?.[id]?.data ?? [];
  };

export const clientSpecialistsReviewsSelector = (state: RootState): { [key: string]: SpecialistReview } =>
  state?.specialistReviews?.clientSpecialistsReviews ?? {};

export const isClientSpecialistReviewExistsSelector =
  (specialistId: string) =>
  (state: RootState): boolean => {
    return !!state?.specialistReviews?.clientSpecialistsReviews?.[specialistId];
  };

export const ratedSpecialistSelector = (state: RootState): string[] | null =>
  state.specialistReviews.reviewedSpecialists ?? null;

export const reviewIsInfinitySelector =
  (id: string) =>
  (state: RootState): boolean =>
    state?.specialistReviews?.reviews?.[id]?.isInfiniteDisabled;
